import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import About from "./pages/about/about";
import "./App.css";
import Login from "./pages/login/login";

function Home() {
  return <h2>Home</h2>;
}

function Contact() {
  return <h2>Contact</h2>;
}

function Nav({ handleLogout }) {
  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <ul style={{ display: "flex", listStyle: "none", margin: 0, padding: 0 }}>
        <li style={{ marginRight: "1rem" }}>
          <Link to="/home">Home</Link>
        </li>
        <li style={{ marginRight: "1rem" }}>
          <Link to="/about">About</Link>
        </li>
        <li style={{ marginRight: "1rem" }}>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
      <button onClick={handleLogout} style={{ padding: "10px 20px" }}>
        Logout
      </button>
    </nav>
  );
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  return (
    <Router>
      <div>
        {isLoggedIn ? (
          <>
            <Nav handleLogout={handleLogout} />
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/home" element={<Home />} />
            </Routes>
          </>
        ) : (
          <Login onLogin={setIsLoggedIn} />
        )}
      </div>
    </Router>
  );
}

export default App;
